import Vue from 'vue';
import Router from 'vue-router';
import * as Pages from '../pages/index.js';
import { store } from '../App.vue';
import config from 'config';

Vue.use(Router);

const routes = [
  {
    path: '/',
    redirect: '/registration',
  },
  {
    path: '/registration',
    name: 'registration',
    component: Pages.Registration,
    props: { store },
  },
  {
    path: '/registration-success',
    name: 'registration-success',
    component: Pages.RegistrationSuccess,
  },
  {
    path: '/contact',
    name: 'contact',
    component: Pages.Contact,
  },
  {
    path: '/impressum',
    name: 'impressum',
    component: Pages.Impressum,
  },
  {
    path: '/error',
    name: 'error',
    component: Pages.Error,
  },
  {
    path: '/reload',
    name: 'reload',
    component: Pages.Reload,
  },
  {
    path: '/blank',
    name: 'blank',
    component: Pages.Blank,
  },
  {
    path: '*',
    component: Pages.NotFound,
  }
];

if (config.debugMode) {
  routes.push({
    path: '/index',
    name: 'index',
    component: Pages.Index,
  });
}

export default new Router({
  routes,
});



// WEBPACK FOOTER //
// ./src/app/router.js